import React from 'react';
import { Switch } from 'antd';
import { noop } from 'lodash-es';

const Toggle = ({ checked, disabled, onChange = noop }) => (
  <Switch checked={checked} disabled={disabled} onChange={onChange} />
);

export default Toggle;
